var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{class:`loader ${(_vm.absolute) ? 'abs' : ''}`},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-content"},[_c('img',{attrs:{"src":"/img/loading.gif","alt":"Загрузка..."}})])
}]

export { render, staticRenderFns }